import { useEffect } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLocale } from '../../contexts/LocaleContext';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import { FAQ_ITEMS, isValidCategory } from '../../data/faqSupportContent';
import { FaqBreadcrumb, FaqExpertSection } from './FaqSupportShared';
import '../AllCss/FaqSupport.css';

function FaqSupportCategory() {
  const { categoryId } = useParams();
  const { t } = useLocale();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [categoryId]);

  if (!isValidCategory(categoryId)) {
    return <Navigate to="/faq-support" replace />;
  }

  const questions = FAQ_ITEMS[categoryId];
  const categoryLabel = t(`faqSupport.categories.${categoryId}`);

  return (
    <div className="faq-page">
      <Navbar />

      <section className="faq-sub-hero">
        <div className="faq-shell faq-sub-hero-inner">
          <FaqBreadcrumb
            items={[
              { label: t('faqSupport.helpCenter'), to: '/faq-support' },
              { label: categoryLabel },
            ]}
          />
          <h1 className="faq-sub-title">{categoryLabel}</h1>
          <p className="faq-sub-lead">{t(`faqSupport.categoryDesc.${categoryId}`)}</p>
        </div>
      </section>

      <section className="faq-question-list-section">
        <div className="faq-shell">
          <ul className="faq-question-list">
            {questions.map((questionId) => (
              <li key={questionId}>
                <Link
                  to={`/faq-support/${categoryId}/${questionId}`}
                  className="faq-question-link"
                >
                  <span>{t(`faqSupport.questions.${categoryId}.${questionId}.q`)}</span>
                  <ArrowRight size={18} strokeWidth={2.25} aria-hidden />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <FaqExpertSection />
      <Footer />
    </div>
  );
}

export default FaqSupportCategory;
